<template>

  <span>
    
    <BaseCardContentOnly :isLoading="[getCreditControlLoading]">
      
      <template #title>Credit Control</template>

      <template #content>

        <v-row>

          <BaseLabelAndInfo important width="4">
            <template #label>Status</template>
            <template #value>{{getCreditControl.status | customPlaceholder}}</template>
          </BaseLabelAndInfo>

          <BaseLabelAndInfo width="8">
            <template #label >
              Status Reason
              <v-icon v-if="!statusReasonEdit" small @click="statusReasonEdit=true">edit</v-icon>
            </template>
            <template #value>
              <div v-if="!statusReasonEdit">{{getCreditControl.status_reason | customPlaceholder}}</div>
              <div v-else class="d-flex align-center justify-center">
                <v-select v-model="statusReason" dense outlined hide-details :items="getCreditControlAccountsFilters.statusReasons" :loading="statusReasonUpdating" :disabled="statusReasonUpdating"></v-select>
                <v-icon color="primary" :disabled="statusReasonUpdating" @click="updateStatusReason">check</v-icon>
                <v-icon color="error" :disabled="statusReasonUpdating" @click="close">close</v-icon>
              </div>
            </template>
          </BaseLabelAndInfo>

        </v-row>

        <v-row>
          
          <BaseLabelAndInfo important width="4">
            <template #label>Balance</template>
            <template #value>{{getCreditControl.balance | formatCurrency}}</template>
          </BaseLabelAndInfo>
          
          <BaseLabelAndInfo width="8">
            <template #label>
              Quick Note
              <v-icon small @click="quickNoteOpen=true">edit</v-icon>
            </template>
            <template #value>{{getCreditControl.quick_note | customPlaceholder}}</template>
          </BaseLabelAndInfo>

        </v-row>

        <v-row>
          
          <BaseLabelAndInfo important width="4">
            <template #label>
              Counter
              <BaseInfoTooltip top>How many days the customer has been in the Credit Control funnel</BaseInfoTooltip>
            </template>
            <template #value>{{getCreditControl.counter | customPlaceholder}}</template>
          </BaseLabelAndInfo>
          
          <BaseLabelAndInfo important width="4">
            <template #label>
              Action Days
              <BaseInfoTooltip top>The day of the communications journey the customer is on</BaseInfoTooltip>
            </template>
            <template #value>{{getCreditControl.actions_days | customPlaceholder}}</template>
          </BaseLabelAndInfo>
          
          <BaseLabelAndInfo important width="4">
            <template #label>
              Days In Debt
              <BaseInfoTooltip top>How many days the customer has been in debt</BaseInfoTooltip>
            </template>
            <template #value>{{getCreditControl.debt_days | customPlaceholder}}</template>
          </BaseLabelAndInfo>

        </v-row>

      </template>

    </BaseCardContentOnly>

    <QuickNoteDialog v-model="quickNoteOpen" />

  </span>

</template>

<script>

  import { mapActions, mapGetters } from 'vuex';

  import QuickNoteDialog from './QuickNoteDialog';

  export default {

    components: { QuickNoteDialog },

    computed: {
      ...mapGetters('creditControl',['getCreditControl','getCreditControlLoading']),
      ...mapGetters('creditControlDashboard', ['getCreditControlAccountsFilters']),
    },
    
    data() {
      return {
        quickNoteOpen: false,
        statusReasonEdit: false,
        statusReason: '',
        statusReasonUpdating: false,
      }
    },

    watch: {
      getCreditControl: {
        handler(newVal) {
          if(newVal.status_reason) {
            this.statusReason = this.getCreditControl.status_reason;
          }
        }
      }
    },

    methods: {
      ...mapActions('creditControl', ['updateAccount']),

      async updateStatusReason() {
        this.statusReasonUpdating = true;
        await this.updateAccount({ account_id: this.$route.params.id ,data: { status_reason: this.statusReason } });
        this.statusReasonEdit = false;
        this.statusReasonUpdating = false;
      },

      close() {
        this.statusReason = this.getCreditControl.status_reason;
        this.statusReasonEdit = false;
      }
    },
  }

</script>

<style lang="scss" scoped></style>
